import { createFileRoute } from '@tanstack/react-router'
import { JournalEntryDetail } from '@thom/folio-ui/pages/journal-entry'

export const Route = createFileRoute('/_authenticated/$client/$domain/$slug/journal/$entry')({
	component: JournalEntryDetail,
})
